var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex-1 px-3 py-5 sm:px-12 sm:py-8 font-outfit" },
    [
      _vm._m(0),
      _c("div", { staticClass: "grid grid-cols-1 sm:grid-cols-2 gap-8" }, [
        _c("div", { staticClass: "flex items-start flex-wrap" }, [
          _c(
            "ul",
            {
              staticClass:
                "list-disc pl-5 space-y-1 text-sm leading-6 sm:leading-snug sm:text-base text-gray-400",
            },
            _vm._l(_vm.data.support_type, function (service, index) {
              return _c("li", { key: index }, [
                _vm._v(" " + _vm._s(service || "N/A") + " "),
              ])
            }),
            0
          ),
        ]),
      ]),
      _c("div", { staticClass: "mt-4" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Frequency"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(" " + _vm._s(_vm.data.frequency || "N/A") + " "),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass:
          "justify-between items-center mb-4 pb-4 borderMainClientProfile hidden sm:flex",
      },
      [
        _c("h2", { staticClass: "text-lg font-normal" }, [
          _vm._v("Required Services"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }